import React from 'react';
import { connect } from 'react-redux';
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';

interface ReduxStateProps {
    selfserveReducer: any,
}

const DeviceDetail = (props: ReduxStateProps) => {
    let deviceBrand = props.selfserveReducer.planDetails.device_detail.brand ? props.selfserveReducer.planDetails.device_detail.brand + ' ' : ''
    let deviceModel = props.selfserveReducer.planDetails.device_detail.model ? props.selfserveReducer.planDetails.device_detail.model + ' ' : ''
    let deviceCategory = props.selfserveReducer.planDetails.device_detail.category_type ? props.selfserveReducer.planDetails.device_detail.category_type : ''
    let deviceName = deviceBrand + deviceModel + deviceCategory
    return (
        <div className={styles.parent}>
            <div className={styles.box}>Device: {deviceName}</div>
            <div className={styles.box}>OSID: {props.selfserveReducer.planDetails.osid}</div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(DeviceDetail);